// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__y2jb2","selects":"Documents_selects__2wzKI"};